import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { Panel, Flex, Text, TEXT_VARIANT_BOLD } from 'mailup-web-components'
import { messageDetailsState } from 'Hooks/useMessageDetails'
import PropTypes from 'prop-types'
import { storeGet } from 'Helpers/localStorage'
import { STORE_KEY_LIST } from 'Constants/'
import { fromUTCtoZoneFormatted } from 'Helpers/dates'

const BoxMessageInfo = ({ idMessage }) => {
  const intl = useIntl()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const { subject, note, creationDate, size } = useRecoilValue(
    messageDetailsState(idMessage)
  )

  return (
    <Panel>
      <Flex flexDirection='column' rowGap='8px'>
        <Flex columnGap='24px'>
          <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
            {intl.formatMessage({ id: 'Load.MessageSummary.SubjectLabel' })}
          </Text>
          <Text htmlElement='span'>{subject}</Text>
        </Flex>
        <Flex columnGap='24px'>
          <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
            {intl.formatMessage({ id: 'Load.MessageSummary.NoteLabel' })}
          </Text>
          <Text htmlElement='span'>{note === '' ? '-' : note}</Text>
        </Flex>
        <Flex columnGap='16px'>
          <Flex columnGap='24px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({ id: 'Load.MessageSummary.MessageId' })}
            </Text>
            <Text htmlElement='span'>{idMessage}</Text>
          </Flex>
          <Flex columnGap='24px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({ id: 'Load.MessageSummary.SizeLabel' })}
            </Text>
            <Text htmlElement='span'>
              {intl.formatNumber(size / 1024, {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
              })}{' '}
              KB
            </Text>
          </Flex>
          <Flex columnGap='24px'>
            <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
              {intl.formatMessage({
                id: 'Load.MessageSummary.createdDateLabel'
              })}
            </Text>
            <Text htmlElement='span'>
              {fromUTCtoZoneFormatted(creationDate, TimeZoneCode, 'YYYY-MM-DD')}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Panel>
  )
}

BoxMessageInfo.propTypes = {
  idMessage: PropTypes.number
}

export default BoxMessageInfo
